/* eslint-disable react-hooks/exhaustive-deps */
import {
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { displayBinaryImage, roundToTwoDecimals } from "Helper";
import moment from "moment";
import { useEffect } from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDebounce } from "use-debounce";
import DynamicAutocomplete from "./DynamicAutocomplete";
import { FadeLoader } from "react-spinners";
import { ArrowLeftIcon } from "@heroicons/react/outline";
import PdfDownloadButton from "DashboardManagementPlatform/Report/pdf/PdfDownloadButton";
import { ROUTES } from "Route/ConstantRoute";
import { decryptNik } from "Config/cripto";

const ReportCustemTableDetails = ({
  params,
  targets,
  detailData,
  sxCustem,
  filtersConfig,
  filters,
  handleFilterChange,
  isLoading,
  headerData,
  error,
  Data,
  onClickCreate,
  isAction,
  onSearchData,
  onClickShow,
  onEditData,
  onDeleteData,
  page,
  rowsPerPage,
  TablePagination,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;

  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 1000);

  const goBack = () => {
    navigate(ROUTES.report.report_home);
  };

  useEffect(() => {
    onSearchData(debouncedSearch);
  }, [debouncedSearch]);
  return (
    <TableContainer
      className="rounded-2xl bg-white"
      style={{
        boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
        border: "0.5px solid #fafafa",
        borderRadius: "10px",
      }}
      component={Paper}
    >
      <div className="flex justify-between items-center px-5 pt-5 w-full">
        <div className="w-2/4">
          <button
            type="submit"
            onClick={goBack}
            disabled={isLoading}
            className="bg-zinc-200 h-11 flex w-auto justify-center items-center rounded-xl hover:bg-gray-100 px-3 py-1.5 text-md font-semibold leading-6 text-black focus-visible:outline shadow-md focus-visible:outline-2 focus-visible:outline-offset-2"
          >
            <ArrowLeftIcon className="h-6 w-auto pr-2" />
            Kembali
          </button>
        </div>
      </div>
      <div className="flex justify-between items-center py-5 px-5 w-full">
        <div className="flex flex-wrap gap-3 w-full   ">
          {filters.map((f, idx) => (
            <DynamicAutocomplete
              key={idx}
              label={f.label}
              options={f.options}
              value={f.value}
              type={f.type}
              error={error}
              onChange={(val) => handleFilterChange(f.key, val)}
              multiple={f.multiple}
              sx={{
                minWidth: {
                  xs: "100%",
                  sm: sxCustem !== null ? sxCustem(f) : 100,
                },
              }}
              loading={f.isLoading}
            />
          ))}
        </div>
        <div className="">
          <PdfDownloadButton
            targets={targets}
            detailData={detailData}
            isLoading={isLoading}
            params={params}
          />
        </div>
        {isAction.isAdd ? (
          <button
            className="h-11 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            onClick={onClickCreate}
          >
            Tambah Data
          </button>
        ) : (
          <div></div>
        )}
      </div>

      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead
          sx={{
            fontFamily: "monospace",
            backgroundColor: "#F5F5F7",
            color: "#4C4E64",
          }}
        >
          <TableRow>
            <TableCell align="center" width="5%" sx={{ fontWeight: "bold" }}>
              No
            </TableCell>
            {headerData.map((header, index) => (
              <TableCell
                key={index}
                align={header.align}
                style={{ width: header.width }}
                sx={{ fontWeight: "bold" }}
              >
                {header.label}
              </TableCell>
            ))}
            {isAction &&
            (isAction.isShow || isAction.isEdit || isAction.isDelete) ? (
              <TableCell align="center" sx={{ fontWeight: "bold" }}>
                Aksi
              </TableCell>
            ) : null}
          </TableRow>
        </TableHead>

        {isLoading ? (
          <TableBody>
            <TableRow>
              <TableCell
                style={{
                  height: 100,
                }}
                colSpan={headerData.length + 2}
                align="center"
              >
                <div className="flex items-center justify-center py-6 gap-3">
                  <div className="scale-57">
                    <FadeLoader height={10} width={5} color="#26a0fc" />
                  </div>
                  <div className="text-sm" style={{ fontFamily: "Poppins" }}>
                    Sedang memuat. . .
                  </div>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
          <TableBody>
            {Data?.length > 0 ? (
              Data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell align="center" width="5%">
                    {page * rowsPerPage + index + 1}
                  </TableCell>
                  <TableCell align="left">
                    {row?.nama_target === null ? "-" : row?.nama_target}
                  </TableCell>
                  <TableCell align="center">
                    {row?.nik_target === null
                      ? "-"
                      : decryptNik(row?.nik_target)}
                  </TableCell>
                  <TableCell align="center">
                    {row?.gender_target === null ? "-" : row?.gender_target}
                  </TableCell>
                  <TableCell align="center" style={{ verticalAlign: "middle" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        // src={displayBinaryImage(row?.crop_image)}
                        src={row?.crop_image || "/asset/defaultImg.jpeg"}
                        alt="target"
                        className="object-cover border border-1 rounded-sm"
                        style={{ width: "50px", height: "50px" }}
                      />
                    </div>
                  </TableCell>
                  <TableCell align="center" style={{ verticalAlign: "middle" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {row?.is_dpo ? (
                        <img
                          // src={displayBinaryImage(row?.full_frame)}
                          src={row?.full_frame || "/asset/defaultImg.jpeg"}
                          alt="target"
                          className="object-cover border border-1 rounded-sm"
                          style={{ width: "100px", height: "50px" }}
                        />
                      ) : (
                        "-"
                      )}
                    </div>
                  </TableCell>
                  <TableCell align="center" style={{ verticalAlign: "middle" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        // src={displayBinaryImage(row?.person_face)}
                        src={row?.person_face || "/asset/defaultImg.jpeg"}
                        alt="target"
                        className="object-cover border border-1 rounded-sm"
                        style={{ width: "50px", height: "50px" }}
                      />
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    {row?.similarity === null
                      ? "-"
                      : `${roundToTwoDecimals(row?.similarity)}%`}
                  </TableCell>
                  <TableCell align="center">
                    <span
                      className={row?.is_dpo ? "font-bold text-red-600" : ""}
                    >
                      {row?.is_dpo ? "DPO" : "Tidak Dicari"}
                    </span>
                  </TableCell>
                  <TableCell align="center">
                    {moment(row?.dateDetected).utc().format("DD MMMM YYYY")}
                  </TableCell>

                  {isAction &&
                  (isAction.isShow || isAction.isEdit || isAction.isDelete) ? (
                    <TableCell align="center">
                      <div className="flex justify-center gap-2">
                        {isAction.isShow ? (
                          <div>
                            <button
                              className="h-10 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                              onClick={() => onClickShow(row)}
                            >
                              <i className="ri-eye-line"></i>
                            </button>
                          </div>
                        ) : null}

                        {isAction.isEdit ? (
                          <div>
                            <button
                              className="h-10 flex w-auto justify-center items-center rounded-xl bg-amber-500 hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                              onClick={() => onEditData(row)}
                            >
                              <i className="ri-pencil-line"></i>
                            </button>
                          </div>
                        ) : null}

                        {isAction.isDelete ? (
                          <div>
                            <button
                              className="bg-rose-900 h-10 flex w-auto justify-center items-center rounded-xl hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                              onClick={() => onDeleteData(row)}
                            >
                              <i className="ri-delete-bin-6-line"></i>
                            </button>
                          </div>
                        ) : null}
                      </div>
                    </TableCell>
                  ) : null}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  style={{
                    height: 100,
                  }}
                  colSpan={headerData.length + 2}
                  align="center"
                >
                  <p
                    className="text-sm"
                    style={{
                      fontFamily: "Poppins",
                    }}
                  >
                    Tidak Ada Data
                  </p>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        )}
      </Table>
      {TablePagination}
    </TableContainer>
  );
};

export default ReportCustemTableDetails;
